import React, { Fragment, useEffect, useState } from 'react'
import SelectDropdown from '../../UI/SelectDropdown';
import closeIcon from '../../images/icons/close_icon.svg';
import { connect } from 'react-redux';
import { closeOrderPopUp } from '../../action/hCommerce2';
import Camera from './Camera';
import { getDefaultAnalyticsLabel } from '../../JS/utility';
import { sendAnalytics } from '../../../action/homeAction';
import { withTranslation } from 'react-i18next';
import AccompanyingGuestFreeFormEditDetails from './accompanyingGuestFreeFormEditDetails';
import { CMSPath } from '../../../config/constant';

const AccompanyingGuestFreeForm = (props) => {

    const { t } = props;
    const [accompanyGuests, setAccompanyGuests] = useState([]);
    const [renderGuestDetailForm, setRenderGuestDetailsForm] = useState(false);
    const [editAccompanyGuestIndex, setEditAccompanyGuestIndex] = useState(null);

    React.useEffect(() => {

        if (props.accompanyGuests.length > 0) {
            setAccompanyGuests(props.accompanyGuests.map(guest => ({ profileId: guest.profileId, nameTitle: guest.nameTitle || "", firstName: guest.firstName || guest.name3, lastName: guest.lastName || guest.name1, age: guest.age, guestType: guest.guestType })));
        }

        let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
        const checkin_companion_guest_event_sent = localStorage.getItem("checkin_companion_guest_event_sent")
        if (!checkin_companion_guest_event_sent)
            props.sendAnalytics(
                null, // as no guesdetails in logout state 
                props.currentWidgetObj.widgetType || "Mobile Check-in",
                "COMPANION DETAILS",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "pageName": "COMPANION DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken") },
                0,
                false, // guest is not logged in
                () => localStorage.setItem("checkin_companion_guest_event_sent", true)
            );
    }, [])


    const enableGuestDetailForm = (index) => {
        setEditAccompanyGuestIndex(index);
        setRenderGuestDetailsForm(true);
    }

    const disableGuestDetailForm = () => {
        setEditAccompanyGuestIndex(null);
        setRenderGuestDetailsForm(false);
    }


    const addAccompanyGuest = (data) => {
        setAccompanyGuests(prevData => {
            if (editAccompanyGuestIndex || editAccompanyGuestIndex == 0) {
                const newData = [...prevData];
                newData[editAccompanyGuestIndex] = data;
                return newData;
            } else {
                return [...prevData, data];
            }
        });

        disableGuestDetailForm();
    };

    const removeAccompanyGuest = (index) => {
        const updatedAccompanyGuests = [...accompanyGuests];
        updatedAccompanyGuests.splice(index, 1);
        setAccompanyGuests(updatedAccompanyGuests);
    }

    const handleGuestDetailsNext = () => {
        let nextStep = true;
        console.log("Setting Accompaning Guest" + JSON.stringify(accompanyGuests))

        accompanyGuests.forEach((guest) => {
            if (guest.firstName == "" || guest.lastName == "") {
                props.closeOrderPopUp(true, "Please enter all the fields to proceed", "", true)
                nextStep = false;
            }

            if (guest.guestType == "child" && (guest.age == null || guest.age == "")) {
                props.closeOrderPopUp(true, "Please enter all the fields to proceed", "", true)
                nextStep = false;
            }
        })

        if (nextStep) {
            props.setAccompanyGuestData(accompanyGuests)
            props.next()
        }
    }

    return !renderGuestDetailForm ? (
        <Fragment>
            <div className="main-container" style={{ background: "url('theme/images/background/08MEDubai-Atrium.jpg') center center no-repeat", backgroundSize: "cover", backgroundAttachment: "fixed" }}>
                <header className="inner-pages w-footer subpages">
                    <a onClick={props.back} className="button-back"></a>
                    <div className="heading align-center">
                        <div class="splash-brand">
                            <img src={`${CMSPath}${props.logo}`} />
                        </div>
                        {/* <p className="bold">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</p> */}
                    </div>
                </header>
                <section class="widgets padding-0 margin-0 container-bg">

                    <div class="widget-header widget-header-checkin-inner">
                        { props.currentWidgetObj.widgetHeaderImageUrl && 
                            <div class="widget-header-img">
                                <img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
                            </div>
                        }
                        <div class="widget-header-title">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.preCheckIn_heading') : t('check_in.guest_checkin')}</div>
                    </div>

                    <div class="widgets" style={{ paddingBottom: "10rem" }}>
                        <div class="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                        </div>
                        <div class="form-window">
                            <div class="form-window-heading">Add Companion</div>
                            <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1" style={{ borderColor: "#ccc" }}>
                                <p>Add your companions here</p>
                                <div class="form-row margin-bottom-1">
                                    {
                                        accompanyGuests.map((guest, index) => {
                                            return (
                                                <>
                                                    <div class="companion-section">
                                                        <span class="guest-name">{guest.nameTitle ? guest.nameTitle + " " + guest.firstName + " " + guest.lastName : guest.firstName + " " + guest.lastName}</span>
                                                        <span class="fa fa-edit" onClick={() => enableGuestDetailForm(index)}></span>
                                                        {!guest.profileId && <span onClick={() => removeAccompanyGuest(index)} class="fa fa-times"></span>}
                                                    </div>
                                                </>
                                            )
                                        })
                                    }
                                    <button onClick={() => enableGuestDetailForm(null)} class="primary w-100 margin-bottom-1"><span class="fa fa-user-plus margin-right-1"></span>Add Companion</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <footer class="button-controls">
                    <section class="padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                        <button onClick={handleGuestDetailsNext} class="primary w-100 all-caps margin-bottom-1">{props.currentWidgetObj.widgetType == "Pre Check-in" ? t('pre_checkIn.precheckin') : t('check_in.checkin')}</button>
                    </section>
                </footer>
            </div>
        </Fragment>
    )
        : <AccompanyingGuestFreeFormEditDetails accompanyGuestDetails={editAccompanyGuestIndex || editAccompanyGuestIndex == 0 ? accompanyGuests[editAccompanyGuestIndex] : null} back={props.back} save={(data) => addAccompanyGuest(data)} cancel={disableGuestDetailForm} />
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        accompanyGuests: state.store2.accompanyGuests,
        guestDetail: state.store.home.guestDetails,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(
    mapStateToProps,
    {
        closeOrderPopUp,
        sendAnalytics
    }
)(withTranslation('translations')(AccompanyingGuestFreeForm));